import { Flex } from 'foundations-components/components/Flex';
import PartnerProgramBanner from 'pricing-pages-ui/components/banners/PartnerProgramBanner';
import PromotionBannerContainer from 'pricing-pages-ui/components/banners/PromotionBannerContainer';
import EnvironmentWrapper from 'pricing-pages-ui/components/common/env/EnvironmentWrapper';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import FintechFireAlarmBanner from '../common/FintechFireAlarmBanner';
import ActiveQuoteBanner from './ActiveQuoteBanner';
import BannerHierarchySection from './BannerHierarchySection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BannerSection = ({
  productLine = ProductLines.MARKETING,
  screen
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    display: "flex",
    flexDirection: "column",
    inlineSize: "100%",
    rowGap: "400",
    marginBlockEnd: "400",
    children: [/*#__PURE__*/_jsx(FintechFireAlarmBanner, {}), /*#__PURE__*/_jsx(PromotionBannerContainer, {
      productLine: productLine
    }), /*#__PURE__*/_jsx(EnvironmentWrapper, {
      authedNode: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(BannerHierarchySection, {}), /*#__PURE__*/_jsx(PartnerProgramBanner, {}), /*#__PURE__*/_jsx(ActiveQuoteBanner, {
          productLine: productLine,
          screen: screen
        })]
      }),
      publicNode: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(BannerHierarchySection, {})
      })
    })]
  });
};
export default BannerSection;